export default __webpack_public_path__ + "static/media/habitude.0ab2cff7.png";